import { render, staticRenderFns } from "./TransactionHero.vue?vue&type=template&id=64a7d20b&scoped=true&"
import script from "./TransactionHero.vue?vue&type=script&lang=js&"
export * from "./TransactionHero.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHero.vue?vue&type=style&index=0&id=64a7d20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7d20b",
  null
  
)

export default component.exports